import $ from 'jquery';
import { io } from 'socket.io-client';

export default class Wiz {
    public namespace: string = '';

    constructor(public baseuri: string) { }

    public app(namespace: string) {
        const instance = new Wiz(this.baseuri);
        instance.namespace = namespace;
        return instance;
    }

    public project() {
        const cookieName = 'season-wiz-project=';
        const cookie = document.cookie
            .split(';')
            .map(value => value.trim())
            .find(value => value.startsWith(cookieName));

        return cookie ? cookie.substring(cookieName.length) : 'main';
    }

    public socket() {
        let socketNamespace = `${this.baseuri}/app/${this.project()}`;
        if (this.namespace) socketNamespace += `/${this.namespace}`;
        return io(socketNamespace);
    }

    public url(functionName: string) {
        const name = functionName.startsWith('/') ? functionName.substring(1) : functionName;
        return `${this.baseuri}/api/${this.namespace}/${name}`;
    }

    public call(functionName: string, data: object = {}, options: object = {}) {
        return new Promise(resolve => {
            $.ajax({
                url: this.url(functionName),
                type: 'POST',
                data,
                ...options
            }).always(response => resolve(response));
        });
    }
}
